import * as React from 'react';
import Theme from '../../../styles/Theme/Theme';
//import * as IconsLibrary from '../../../assets/icons/_index';
import * as IconsLibrary from './SVGLibrary';
import styled from "styled-components";

const IconWrapper = styled.div`
    height: ${props => (props.$bgsize ? props.$bgsize : null)};
    width: ${props => (props.$bgsize ? props.$bgsize : null)};
    background-color: ${props => (props.$bgColor ? Theme.color[props.$bgColor] : null)};
    border-radius: ${props => (props.bgradius ? Theme.radius[props.bgradius] : '50%')};
    padding: ${props => (props.$bgColor ? '4px' : '0')};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CustomIcon = ({ icon, iconsize, color, bgColor, bgradius, ...rest }) => {
    if (icon || bgColor) {
        const windowSize = window.screen.width;
        let size;
        let bgsize;
        if (windowSize >= Theme.deviceValue.videowall) {
            size = Theme.icons.videowall[iconsize];
        } else {
            size = bgColor ? Theme.iconsWithBg.desktop[iconsize] : Theme.icons.desktop[iconsize]
            bgsize = bgColor ? (Theme.icons.desktop[iconsize] + 'px') : null
        }

        let Component = IconsLibrary[icon];

        return (
            <IconWrapper $bgColor={bgColor} $bgsize={bgsize} bgradius={bgradius}>
                {Component && typeof Component !== 'undefined' 
                ? <Component {...rest} size={size} color={Theme.color[color]} /> 
                : console.error('ERROR: SVG icon (' + icon + ') does not exist')
                }

            </IconWrapper>
        )


      
    }
    return null;
};

export default CustomIcon;
